import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianRanger extends Guardian {
    constructor(golden = false) {
        super("guardian_ranger_male", Guardian.TYPE_RANGER, golden);

        this.setIdleAnims(["idle1_ranger"]);
        this.setAttackAnims(["attack_ranger"]);
        this.setDamageAnims(["damage_ranger"]);
        this.setDefeatAnims(["defeat_ranger"]);
        this.setVictoryAnims(["victory_ranger"]);
        this.setWeaponRevealAnims(["weapon_reveal_ranger"]);

        this._attackSoundName = "sfx_guardian_spear_attack_00";
    }
}